import "./App.css";
import Closed from "./Pages/Closed.js";

function App() {
  return (
    <div className="App">
      <Closed />
    </div>
  );
}

export default App;
